import React, { Component } from 'react'

import CustomerCart from '../components/CustomerCart'
import CustomerExtraDelivery from '../components/CustomerExtraDelivery'

class Customer extends Component{
  constructor() {
    super();
    this.state = {
      user: {
        email: '',
        telephone: '',
        password_token: '',
        password_tries: '',
      },
      cart_details: [],
      carts: [],
      showEmailPopup: false
    }

    this.handleInputChange = this.handleInputChange.bind(this)
    this.getUser = this.getUser.bind(this)
    this.updateUser = this.updateUser.bind(this)
    this.toggleEmailPopup = this.toggleEmailPopup.bind(this)
  }

  getUser = () => {
    const user_id = this.props.match.params.id
    const token = localStorage.getItem("admin-token")
    const headers = { "Content-Type": "application/json",};
    headers["Authorization"] = `Token ${token}`;
    fetch(`/api/admin/customer/${user_id}`, {headers, method: "GET"})
      .then(res => {
        if (res.status === 200) {
          res.json().then(data => {
            this.setState({
              user: data.user,
              cart_details: data.cart_details,
              carts: data.carts
            })
            console.log(data.user.type)
          })
          .catch(error => console.log(res))
        } else {
          console.log("Server Error!");
          throw res;
        }
      })
  }

  updateUser = (event) => {
    const user_id = this.props.match.params.id
    const token = localStorage.getItem("admin-token")
    const headers = { "Content-Type": "application/json",};
    const user = {user: {...this.state.user}}
    const body = JSON.stringify(user);
    headers["Authorization"] = `Token ${token}`;
    fetch(`/api/admin/customer/${user_id}`, {headers, body, method: "POST"})
      .then(res => {
        if (res.status === 200) {
          this.setState({isUpdated: true})
        } else {
          console.log("Server Error!");
          throw res;
        }
      })
  }

  toggleEmailPopup() {
    this.setState(state => ({showEmailPopup: !state.showEmailPopup}))
  }

  handleInputChange(event) {
    const value = event.target.value;
    const name = event.target.name;

    this.setState(prevState => ({ user: {...prevState.user, [name]:value}}));
  }

  componentDidMount() {
    this.getUser()
  }

  render() {
    return(
      <div className="Customer">
        {/*
          this.state.showEmailPopup
          ?
          <CustomerEmail toggleEmailPopup={this.toggleEmailPopup} />
          :
          null
        */}
        <h1>Customer - {this.props.match.params.id}</h1>
        <button className="Add-btn" onClick={this.updateUser}>Spara</button>
        {
          this.state.isUpdated
          ?
          <p className="Admin-Product-success">User has been updated</p>
          :
          null
        }
        <div className="Products-body">
          <form>
            <h3 className="Customer-top-h">Konto & leverans uppgifter</h3>
              <div className="Customer-form-row">
                <div className="Customer-form-section">
                  <label>Email</label>
                  <input
                    className="Customer-input"
                    type="email"
                    placeholder="Email"
                    name="email"
                    value={this.state.user.email}
                    onChange={this.handleInputChange}
                  />
                </div>
              </div>
            <div className="Customer-form-row">
              <div className="Customer-form-section">
                <label>Telefonummer</label>
                <input
                  className="Customer-input"
                  type="text"
                  placeholder="Telefonummer"
                  name="delivery_telephone"
                  value={this.state.user.telephone}
                  onChange={this.handleInputChange}
                />
              </div>
            </div>
            <h3>Logga in med kod (endast läsbar)</h3>
            <div className="Customer-form-row">
              <div className="Customer-form-section">
                <label>Login Kod (5 Tecken)</label>
                <input
                  className="Customer-input"
                  type="text"
                  placeholder="Login kod"
                  name="password_token"
                  value={this.state.user.password_token}
                  onChange={this.handleInputChange}
                />
              </div>
              <div className="Customer-form-section">
                <label>Login Försök (max 3)</label>
                <input
                  className="Customer-input"
                  type="text"
                  placeholder="Login försök"
                  name="password_tries"
                  value={this.state.user.password_tries}
                  onChange={this.handleInputChange}
                />
              </div>
            </div>
            <h4>Har loggat in</h4>
            {
              this.state.user.first_login
              ?
              <p>Kunden har aldrig loggat in</p>
              :
              <p>Kunden har loggat in</p>
            }
          </form>
          <div className="Customer-cart">
            <h3 className="Customer-table-h">Vagn</h3>
            <table>
              <thead>
                <tr>
                  <th>Månad</th>
                  <th>Produkt</th>
                  <th>Antal</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {
                  this.state.cart_details.map((cart, index) => {
                    return (
                      <CustomerCart key={index} {...cart} />
                    )
                  })
                }
              </tbody>
            </table>
          </div>
        </div>
      </div>
    )
  }
}

export default Customer



// WEBPACK FOOTER //
// ./src/containers/admin/containers/Customer.jsx